import InviteUser from "./InviteUser";

function Content({ selectedSubMenu, setIsPageLoading }) {
    return <>
        <h1>{selectedSubMenu}</h1>

        {selectedSubMenu === 'Invite User' && <InviteUser setIsPageLoading={setIsPageLoading} />}
    </>
}

export default Content;